import React from 'react';

import CardPanel from '@elements/CardPanel';
import { getClasses } from '@utils';
import { IGatsbyImageData } from 'gatsby-plugin-image';

import './style.css';

type ImageProps = {
  contentful_id: string;
  title: string;
  gatsbyImageData: IGatsbyImageData;
};

type PageProps = {
  __typename: string;
  contentful_id: string;
  title: string;
  slug: string;
};

type PanelImageProps = {
  item: {
    title: string;
    classes?: string;
    description: {
      description: string;
    };
    images: Array<ImageProps>;
    icons: Array<ImageProps>;
    childPages?: Array<PageProps>;
    textLeft: string,
    textCenter: string,
    textRight: string,
    useFilter: boolean,
  };
};

const PanelImage = ({ item }: PanelImageProps): JSX.Element => {
  const { 
    title, 
    classes = '', 
    images, 
    icons, 
    description, 
    childPages,
    textLeft,
    textCenter,
    textRight,
    useFilter,
  } = item;

  return (
    <div className={`panel-image--main ${classes}`}>
      <section className="panel-image__title">
        <div>
          <hr/>
          <h2>{title}</h2>
          <p>{description?.description}</p>
        </div>
      </section>

      <section className="panel-image__inner">
        {images?.map((image: ImageProps, index: number) => {
          const ctaLink = childPages[index];
          const icon = icons[index];
          const childClassName = getClasses(
            useFilter && `card-panel--use-filter`,
          );
          let titleText = '';

          switch (index) {
            case 0:
              titleText = textLeft;
              break;
            case 1:
              titleText = textCenter;
              break;
            case 2:
              titleText = textRight;
              break;
            default:
              break;
          }

          return (
            <CardPanel
              key={image.contentful_id}
              childClassName={childClassName}
              ctaLink={ctaLink}
              icon={icon}
              image={image}
              titleText={titleText}
            />
          )
        })}
      </section>
    </div>
  );
};

export default PanelImage;
